<template>
    <div class="top-breadcrumbs">
        <p @click="handleGoIndex">运营指南</p>
        <div class="breadcrumbs-icon"></div>
        <span>发布创意</span>
    </div>
    <div class="cont top">
        <div class="title">为什么要发布项目创意？</div>
        <ul style="padding: 0 0 0 20px;">
            <li>验证需求</li>
        </ul>
        <p>通过市场反馈判断创意是否契合用户需求，避免盲目投入。</p>
        <ul>
            <li>验证需求</li>
        </ul>
        <p>获取外界对创意的改进意见，优化项目方向或细节。</p>
        <ul>
            <li>吸引关注</li>
        </ul>
        <p>让潜在支持者、投资者或合作伙伴发现项目价值，积累初始流量。</p>
    </div>
    <div class="cont">
        <div class="title">发布创意的步骤：点击查看详细步骤</div>
        <div class="tab_title">手机端</div>
        <div class="tab_tips">
            <div class="item">
                <p>第一步</p>
                <el-image 
                    class="enlarged"
                    :src="step1"
                    :preview-src-list="imageList"
                    :initial-index="0"
                    :preview-teleported="true"
                    fit="contain"
                    loading="lazy"
                />
            </div>
            <div class="item">
                <p>第二步</p>
                <el-image 
                    class="enlarged"
                    :src="step2"
                    :preview-src-list="imageList"
                    :initial-index="1"
                    :preview-teleported="true"
                    fit="contain"
                    loading="lazy"
                />
            </div>
            <div class="item">
                <p>第三步</p>
                <el-image 
                    class="enlarged"
                    :src="step3"
                    :preview-src-list="imageList"
                    :preview-teleported="true"
                    :initial-index="2"
                    fit="contain"
                    loading="lazy"
                />
            </div>
        </div>
    </div>
    <div class="cont">
        <div class="title">发布创意的步骤：点击查看详细步骤</div>
        <div class="tab_title">电脑端</div>
        <p>第一步</p>
        <el-image 
            class="enlarged"
            :src="step1Pc"
            :preview-src-list="imagePcList"
            :initial-index="0"
            :preview-teleported="true"
            fit="contain"
            loading="lazy"
        />
        <p>第二步</p>
        <el-image 
            class="enlarged"
            :src="step2Pc"
            :preview-src-list="imagePcList"
            :initial-index="1"
            :preview-teleported="true"
            fit="contain"
            loading="lazy"
        />
        <p>第三步</p>
        <el-image 
            class="enlarged"
            :src="step3Pc"
            :preview-src-list="imagePcList"
            :initial-index="2"
            :preview-teleported="true"
            fit="contain"
            loading="lazy"
        />
        <p>第四步</p>
        <el-image 
            class="enlarged"
            :src="step4Pc"
            :preview-src-list="imagePcList"
            :initial-index="3"
            :preview-teleported="true"
            fit="contain"
            loading="lazy"
        />
        <el-button type="primary" @click="toPublishCreativity">去发布创意</el-button>
    </div>
</template>

<script setup>
import { useRouter } from 'vue-router'
import domain from '@/service/domain'

// 统一管理CDN地址
const CDN_BASE = 'https://p6.moimg.net/mdwxapp/guide/'

const step1 = `${CDN_BASE}creativity_mobile_step1.png`
const step2 = `${CDN_BASE}creativity_mobile_step2.png`
const step3 = `${CDN_BASE}creativity_mobile_step3.png`
const step1Pc = `${CDN_BASE}creativity_pc_step1.png`
const step2Pc = `${CDN_BASE}creativity_pc_step2.png`
const step3Pc = `${CDN_BASE}creativity_pc_step3.png`
const step4Pc = `${CDN_BASE}creativity_pc_step4.png`

// 图片列表，用于预览
const imageList = [step1, step2, step3]
const imagePcList = [step1Pc, step2Pc, step3Pc, step4Pc]

const router = useRouter()
const toPublishCreativity = () => {
    window.open(`${domain.member}/initiate/idea`)
}
const handleGoIndex = () => {
    if(sessionStorage.getItem('guide_pro_id')){
        router.push(`/project_manage/index/${sessionStorage.getItem('guide_pro_id')}`)
    } else {
        router.push((`/project_manage/index`))
    }
}

</script>

<style lang="scss" scoped>
.top-breadcrumbs{
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
    padding: 0 0 40px 0;
    p{
        color: #7F7F7F;
        cursor: pointer;
    }
    .breadcrumbs-icon{
        width: 14px;
        height: 14px;
        margin: 0 10px;
        background: url('~@/assets/images/icon_right.png') no-repeat center center;
        background-size: contain;
    }
    span{
        color: #1A1A1A;
    }
}
.cont{
    margin: 60px 0 0 0;
    color: #1A1A1A;
    &.top{
        margin: 0;
    }
    ul{
        padding: 20px 0 0 20px;
        li{
            font-weight: 600;
            list-style: disc;
        }
        // li::marker{
        //     color: #00C4A1;
        // }
        +p{
            padding: 10px 0 0 20px;
        }
    }
    .title{
        font-size: 24px;
        font-weight: 600;
        margin: 0 0 25px 0;
    }
    .tab_title{
        font-size: 16px;
        line-height: 1;
        font-weight: 600;
        margin: 0 0 30px 0;
    }
    .tab_tips{
        display: flex;
        align-items: center;
        .item{
            width: 200px;
            margin: 0 30px 0 0;
            p{
                font-size: 14px;
                line-height: 1;
                font-weight: 400;
                margin: 0 0 30px 0;
            }
            .el-image {
                width: 100%;
                height: auto;
                cursor: pointer;
                
                &.enlarged {
                    transform: scale(1.2);
                    transform-origin: center;
                    transition: transform 0.3s ease;
                }
            }
        }
    }
    p{
        font-size: 14px;
        line-height: 1;
    }
    img{
        width: 100%;
        height: auto;
    }
}
</style>